import {addAnalytics} from './analytics'
import XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';

export const exportToCSVNew = (csvData, fileName) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { 'data': ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};


 const exportToCSV = (csvData, fileName, HeadingData) => {
  addAnalytics('Download Excel', fileName+'Excel Download', csvData);
  //const Heading = [['ID','Client'	,'Product Code',	'Mrp',	' Product Code',	'Parent Mrp']]
    // const ws = XLSX.utils.json_to_sheet(csvData);
    const ws = XLSX.utils.json_to_sheet(csvData,{ origin: 'A2', skipHeader: true });
    XLSX.utils.sheet_add_aoa(ws, HeadingData, { origin: 'A1' });
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    FileSaver.saveAs(data, fileName + fileExtension);
  }


export default exportToCSV;

